<template>
  <b-overlay
    :show='loading'
    rounded
    opacity='0.6'
    spinner-small
    spinner-variant='primary'
    class=' w-100'
  >
    <section class='frequently-asked-questions mt-5 mx-2'>
      <modal-confirm-action
        variant='danger'
        refModal='delete-frequently-asked-questions'
        idModal='delete-frequently-asked-questions'
        :loading='loading'
        :description='descriptionRemove'
        :title='titleRemove'
        @confirmed='deleteFrequentlyAskedQuestions'
      />

      <modal-confirm-action
        variant='danger'
        refModal='delete-category-frequently-asked-questions'
        idModal='delete-category-frequently-asked-questions'
        :loading='loading'
        :description='descriptionRemove'
        :title='titleRemove'
        @confirmed='deleteCategoryFrequentlyAskedQuestions'
      />

      <CategoryFrequentlyAskedQuestions
        :categoryFrequentlyAskedQuestionsId="categoryFrequentlyAskedQuestionsId"
        @reload="listCategoriesFrequentlyAskedQuestions"
      >
      </CategoryFrequentlyAskedQuestions>

      <FrequentlyAskedQuestions
        :categoryId="categoryId"
        :frequentlyAskedQuestionsId="frequentlyAskedQuestionsId"
        @reload="listCategoriesFrequentlyAskedQuestions"
      >
      </FrequentlyAskedQuestions>

      <section class="header  ">
        <p>Listagem de questões por categoria </p>

        <button @click="showModalCategoryFrequentlyAskedQuestions(null)">
          <span class="mr-2">Cadastrar nova categoria</span>
          <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.578125 10.59L5.16812 6L0.578125 1.41L1.99812 -6.20702e-08L7.99812 6L1.99813 12L0.578125 10.59Z"
              fill="black" />
          </svg>
        </button>
      </section>

      <section class="categories mt-4">
        <section
          class="category  mb-4"
          v-for="(category, indexCategory) in categoriesFrequentlyAskedQuestions"
          :key="`${category._id}_${indexCategory}`"
        >
          <section class="d-flex justify-content-between flex-wrap align-items-center">
            <section>
              <section>
                <span class="name">{{ category.name }}</span>
              </section>
              <section class="mt-1">
                <span class="count-questions ">{{ category.questions.length }} artigo(s)</span>
              </section>
            </section>

            <section class="d-flex justify-content-between flex-wrap">
              <section class="mr-4">
                <button @click="showModalCategoryFrequentlyAskedQuestions(category._id)">
                  Editar nome da categoria
                </button>
              </section>

              <section class="mr-4">
                <button @click="showModalDeleteCategoryFrequentlyAskedQuestions(category)">
                  Excluir categoria
                </button>
              </section>

              <section class="mr-4">
                <button @click="showModalAddFrequentlyAskedQuestions(category._id)">
                  Cadastrar nova questão
                </button>
              </section>

              <section>
                <img
                  v-if="category.open"
                  v-b-toggle="[category._id]"
                  @click="setOpen(category)"
                  class='transition cursor-pointer rotate'
                  width='25'
                  height='25'
                  src='../assets/images/arrow.svg'
                  alt=''
                />
                <img
                  v-else
                  @click="setOpen(category)"
                  class='transition cursor-pointer'
                  width='25'
                  height='25'
                  src='../assets/images/arrow.svg'
                  alt=''
                />
              </section>
            </section>
          </section>

          <section
            v-if="category.open"
          >
            <section class="line mt-4"></section>
            <section
              class="mt-3 ml-3"
              v-for="(question, indexQuestion) in category.questions"
              :key="`${question._id}_${indexQuestion}`"
            >
              <section class="d-flex justify-content-between align-items-center">
                <section>
                  <ul class="ml-4">
                    <li class="title">{{ question.title }}</li>
                  </ul>
                  <p class="body" v-html="question.body"></p>
                </section>

                <!--Editar Pergunta-->
                <section class="d-flex">
                  <section>
                    <b-icon
                      font-scale='1.6'
                      icon='trash-fill'
                      color='#bc0000'
                      class='cursor-pointer mr-3'
                      @click="showModalDeleteFrequentlyAskedQuestions(question)"
                    >
                    </b-icon>
                  </section>
                  <section>
                    <b-icon
                      font-scale='1.6'
                      icon='pencil-square'
                      class='cursor-pointer mr-3'
                      variant="success"
                      @click="showModalUpdateFrequentlyAskedQuestions(question._id)"
                    >
                    </b-icon>
                  </section>
                </section>
              </section>
              <section v-if="indexQuestion < category.questions.length - 1" class="line-item"></section>
            </section>

          </section>
        </section>

        <section class='w-100 mb-5 mt-3'>
          <b-pagination
            v-if='categoryFrequentlyAskedQuestionsMeta.total > 10'
            align='end'
            :per-page='10'
            v-model='categoryFrequentlyAskedQuestionsMeta.page'
            :total-rows='categoryFrequentlyAskedQuestionsMeta.total'
            first-text='⏮'
            prev-text='⏪'
            next-text='⏩'
            last-text='⏭'
            @page-click='setPage'
          >
          </b-pagination>
        </section>
      </section>
    </section>
  </b-overlay>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CategoryFrequentlyAskedQuestions
  from '../components/FrequentlyAskedQuestions/CategoryFrequentlyAskedQuestions.vue'
import FrequentlyAskedQuestions from '../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions.vue'
import ModalConfirmAction from '../components/ModalConfirmAction.vue'

export default {
  name: 'ManageFrequentlyAskedQuestions',
  components: { ModalConfirmAction, FrequentlyAskedQuestions, CategoryFrequentlyAskedQuestions },
  data() {
    return {
      frequentlyAskedQuestionsDelete: Object,
      editFrequentlyAskedQuestions: false,
      categoryFrequentlyAskedQuestionsId: null,
      categoryFrequentlyAskedQuestions: Object,
      frequentlyAskedQuestionsId: null,
      loading: false,
      categoryId: null,
      descriptionRemove: '',
      titleRemove: ''
    }
  },
  created() {
    const breadcrumb = {
      tab: '',
      page: 'Gerenciamento FAQ',
      subPage: {
        name: 'Gerencie, edite e cadastre novas perguntas',
        active: true
      },
      tabs: []
    }
    this.setBreadcrumb(breadcrumb)
  },
  async mounted() {
    await this.listCategoriesFrequentlyAskedQuestions({})
  },
  computed: {
    user() {
      return this.$store.getters['user/current']
    },
    ...mapGetters('categoryFrequentlyAskedQuestions', {
      categoryFrequentlyAskedQuestionsMeta: 'categoryFrequentlyAskedQuestionsMeta',
      categoriesFrequentlyAskedQuestions: 'categoriesFrequentlyAskedQuestions'
    })
  },
  methods: {
    ...mapActions('userPreferences', {
      handleGetUserPreferences: 'handleGetUserPreferences',
      handleChangUserPreferences: 'handleChangUserPreferences'
    }),
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb'
    }),
    ...mapActions('categoryFrequentlyAskedQuestions', {
      handlePagedList: 'handlePagedList',
      handleSetOpen: 'handleSetOpen',
      handlePagedListRelated: 'handlePagedListRelated',
      handleDeleteCategoryFrequentlyAskedQuestions: 'handleDelete',
    }),
    ...mapActions('frequentlyAskedQuestions', {
      handleCreate: 'handleCreate',
      handleUpdate: 'handleUpdate',
      handleGet: 'handleGet',
      handleDelete: 'handleDelete',
    }),
    async setPage(event, page) {
      await this.listCategoriesFrequentlyAskedQuestions({ page })
    },

    async deleteFrequentlyAskedQuestions() {
      try {
        this.loading = true
        const { data, status, errors } = await this.handleDelete(this.frequentlyAskedQuestionsDelete._id)

        this.loading = false

        let message = errors
        let variant = 'danger'

        if (status === 200 || status === 201) {
          message = data.message
          variant = 'success'
        }

        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.$bvModal.hide('delete-frequently-asked-questions')
        await this.listCategoriesFrequentlyAskedQuestions({})
      } catch (e) {

      }
    },

    async deleteCategoryFrequentlyAskedQuestions() {
      try {
        this.loading = true
        const { data, status, errors } = await this.handleDeleteCategoryFrequentlyAskedQuestions(this.categoryFrequentlyAskedQuestions._id)

        this.loading = false

        let message = errors
        let variant = 'danger'

        if (status === 200 || status === 201) {
          message = data.message
          variant = 'success'
        }

        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.$bvModal.hide('delete-category-frequently-asked-questions')
        await this.listCategoriesFrequentlyAskedQuestions({})
      } catch (e) {

      }
    },

    async setOpen(category) {
      this.loading = true;
      category.open = !category.open
      await this.handleSetOpen(category)
      this.loading = false;
    },

    async listCategoriesFrequentlyAskedQuestions(payload) {
      try {
        this.loading = true
        const params = {
          ...this.categoryFrequentlyAskedQuestionsMeta,
          ...payload
        }
        await this.handlePagedList(params)
        this.loading = false
        this.editFrequentlyAskedQuestions = false
      } catch (e) {

      }
    },

    async showModalDeleteFrequentlyAskedQuestions(frequentlyAskedQuestions) {
      try {
        this.frequentlyAskedQuestionsDelete = frequentlyAskedQuestions
        this.titleRemove = 'Excluir pergunta'
        this.descriptionRemove = `Tem certeza que deseja excluir a pergunta: <strong>${this.frequentlyAskedQuestionsDelete.title}</strong> ?`
        this.$bvModal.show('delete-frequently-asked-questions')
      } catch (e) {

      }
    },

    showModalUpdateFrequentlyAskedQuestions(frequentlyAskedQuestionsId) {
      this.categoryId = null
      this.frequentlyAskedQuestionsId = frequentlyAskedQuestionsId
      setTimeout(() => {
        this.$bvModal.show('frequently-asked-questions')
      }, 100)
    },

    showModalAddFrequentlyAskedQuestions(_id) {
      this.categoryId = _id
      this.frequentlyAskedQuestionsId = null
      setTimeout(() => {
        this.$bvModal.show('frequently-asked-questions')
      }, 100)
    },

    showModalCategoryFrequentlyAskedQuestions(_id) {
      this.categoryFrequentlyAskedQuestionsId = _id
      setTimeout(() => {
        this.$bvModal.show('category-frequently-asked-questions')
      }, 100)
    },

    showModalDeleteCategoryFrequentlyAskedQuestions(categoryFrequentlyAskedQuestions) {
      this.categoryFrequentlyAskedQuestions = categoryFrequentlyAskedQuestions
      this.titleRemove = 'Excluir categoria'
      this.descriptionRemove = `Tem certeza que deseja excluir a categoria: <strong>${this.categoryFrequentlyAskedQuestions.name}</strong> ?`
      setTimeout(() => {
        this.$bvModal.show('delete-category-frequently-asked-questions')
      }, 100)
    },

    hideModalCategoryFrequentlyAskedQuestions() {
      this.$bvModal.hide('category-frequently-asked-questions')
    }
  }
}
</script>

<style lang='scss' scoped>
.frequently-asked-questions {
  .header {
    display: flex;
    justify-content: space-between;
    align-content: end;

    p {
      font-size: 18px;
      font-weight: 700;
      color: #262626;
    }

    button {
      background: #CBD63E;
      border: none;
      padding: 10px 20px;
      font-weight: 600;
      font-size: 16px;
      color: var(--navy-blue);
    }
  }

  .categories {
    .category {
      border: 1px solid #808080;
      padding: 15px;
      border-radius: 4px;

      .name {
        font-weight: 700;
        font-size: 16px;
        color: #262626;
      }

      .count-questions {
        font-weight: 400;
        font-size: 16px;
        color: #262626;
      }

      button {
        background: transparent;
        border: 1px solid #262626;
        height: 30px;
        padding: 0px 10px;
        font-weight: 700;
        font-size: 16px;
        color: #262626;
        border-radius: 4px;
      }
    }

    .line {
      border-top: 1px solid #262626;
      height: 1px;
    }

    .line-item {
      border-top: 1px solid #C0C0C0;
      height: 1px;
    }

    .title {
      font-weight: 700;
      font-size: 16px;
      color: #262626;
    }

    .title-article {
      font-weight: 700;
      font-size: 20px;
      color: #262626;
    }

    .body {
      font-weight: 400;
      font-size: 16px;
      color: #262626;
    }
  }
}

.modal-add-category {
  .header {
    display: flex;
    align-content: start;
    justify-content: space-between;

    p {
      font-size: 20px;
      font-weight: 700;
      color: #262626;
    }
  }
}

.rotate {
  transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);

}

.transition {
  -webkit-transition: -webkit-transform .5s ease-in-out;
  -ms-transition: -ms-transform .5s ease-in-out;
  transition: transform .5s ease-in-out;
}
</style>
